export default __webpack_public_path__ + "static/media/services10.468c9b07.jpg";